module.exports = __webpack_public_path__ + "assets/img/price.3babee01.jpg";